import TakingOrderTable from "./component/TakingOrderTable";

function TakingOrderClosed() {

  return (
    <>
      <TakingOrderTable status={4}/>
    </>
  );
}

export default TakingOrderClosed;
